export default __webpack_public_path__ + "static/media/article-purchase-conversion.278f605b.png";